import { writable } from 'svelte/store';

import { TagBlocksService } from '@client/services/tag-blocks';

import { userStore } from '@client/stores/user';

export function sortBanners(response, cname) {
  if (!Array.isArray(response)) {
    return [];
  }

  const signatures = response.sort((a, b) => a.rulename.localeCompare(b.rulename));

  return (signatures[0]?.highlights || [])
    .sort((a, b) => a.rulename?.localeCompare(b?.rulename))
    .map(
      ({ type, id, rulename, ...rest }) =>
        type === 'ad' &&
        typeof id === 'string' && {
          label: rulename,
          src: `${cname.join('://')}/sig.png?aname=${rulename}`,
          value: rulename,
          ...rest
        }
    )
    .filter(Boolean);
}

function createBannerStore() {
  const { subscribe, set } = writable({
    bannerOptions: [],
    loaded: false
  });

  let isFetching = false;

  async function fetchBanners(cname) {
    try {
      const response = await TagBlocksService.getAll();

      if (response?.status === 405) {
        return;
      }

      const bannerOptions = sortBanners(response, cname);

      set({
        bannerOptions,
        loaded: true
      });
    } catch (error) {
      if (error?.message === 'Canceled' || error?.__CANCEL__) {
        console.info('Request cancelled', { label: 'tagblocks:getAll', reason: 'banner-store' });
        return;
      }

      throw error;
    }
  }

  // Subscribe to userStore's `cname` and reactively fetch banners when it changes
  userStore.subscribe(($userStore) => {
    if (!isFetching) {
      isFetching = true;
      fetchBanners($userStore.cname);
    } else {
      // Refetch banners with updated cname when it changes
      fetchBanners($userStore.cname);
    }
  });

  return {
    subscribe
  };
}

export const bannerStore = createBannerStore();
